import {SpotlightSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {CardsSlider as BaseCardsSlider} from '@aboutyou/ui-components';
import React from 'react';
import {HeightCalcWrapper} from '../../../../../features/HeightCalcWrapper/HeightCalcWrapper';
import {useSelectedTargetGroup} from '../../../../../shared-deprecated/useSelectedTargetGroup';
import {normalizeSpotlightCards} from '../utils/normalizeSpotlightCards';
import {Card} from './Card';

export const CardsSlider: React.FC<SpotlightSection> = ({elements}) => {
  const {targetGroup} = useSelectedTargetGroup();
  const cards = normalizeSpotlightCards(elements);

  return (
    <HeightCalcWrapper>
      <BaseCardsSlider key={targetGroup} CardComponent={Card} cards={cards} />
    </HeightCalcWrapper>
  );
};
